import { getLocaleId } from "../reducers/selectors";
import { useConfigurationRootState } from "./useConfigurationRootState";
/**
 * Get the session id
 * - requires {@linkcode ConfigurationController}
 * - ISO 639-1 code
 * - can be empty string on before {@link startConfiguration}
 * - currently empty when using {@link resumeConfiguration}
 * - might be necessary on print etc
 *
 * @category Hook
 * @category CsConfiguration
 * @export
 * @returns {string}
 */
export function useConfigurationLanguage() {
    const ecsState = useConfigurationRootState();
    return getLocaleId(ecsState);
}
/**
 * @deprecated Use {@linkcode useConfigurationLanguage}
 */
export const useLanguage = useConfigurationLanguage;
//# sourceMappingURL=useConfigurationLanguage.js.map